import { c as _c } from "react/compiler-runtime";
import { useStreamedProjects } from "@hooks/projects/use-streamed-projects";
import { useFetchGroupsOnce } from "@hooks/use-fetch-groups-once";
import { sortProjects } from "@utils/project-utils";
import { matchesAnySearchWord } from "@utils/string-utils";
import { useEffect } from "react";
/** All the projects arrive at once, so there is never a next page to load */
function loadNoMoreProjects() {
  // Nothing to load
}

/**
 * Lists the projects that pass filters the API cannot apply. They are taken from the projects
 * stream, which the map view shares, so the stream is fetched only once however often the user
 * switches between the views or changes the filters. Searching and sorting happen client-side too.
 * The streamed projects only have the ID of their group, so the groups are fetched too, for the
 * table to show the names of the groups.
 */
export function useFilteredStreamedProjects(t0) {
  const $ = _c(17);
  const {
    companyId,
    projectArchivingState,
    sortBy,
    search,
    filterProjects,
    isEnabled
  } = t0;
  let t1;
  if ($[0] !== companyId || $[1] !== isEnabled || $[2] !== projectArchivingState) {
    t1 = {
      companyId,
      projectArchivingState,
      isEnabled
    };
    $[0] = companyId;
    $[1] = isEnabled;
    $[2] = projectArchivingState;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    projects: allProjects,
    fetchingStatus
  } = useStreamedProjects(t1);
  const fetchGroupsOnce = useFetchGroupsOnce(companyId);
  let t2;
  let t3;
  if ($[4] !== fetchGroupsOnce || $[5] !== isEnabled) {
    t2 = () => {
      if (isEnabled) {
        fetchGroupsOnce();
      }
    };
    t3 = [fetchGroupsOnce, isEnabled];
    $[4] = fetchGroupsOnce;
    $[5] = isEnabled;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== allProjects || $[9] !== filterProjects || $[10] !== search || $[11] !== sortBy) {
    const searchedProjects = search ? allProjects.filter(project => matchesAnySearchWord(project.name, search)) : allProjects;
    t4 = sortProjects(filterProjects(searchedProjects), sortBy);
    $[8] = allProjects;
    $[9] = filterProjects;
    $[10] = search;
    $[11] = sortBy;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const projects = t4;
  const t5 = fetchingStatus === "uninitialized" || fetchingStatus === "pending";
  const t6 = fetchingStatus === "succeeded" || fetchingStatus === "rejected";
  let t7;
  if ($[13] !== projects || $[14] !== t5 || $[15] !== t6) {
    t7 = {
      projects,
      isFetchingProjects: t5,
      hasFetchedFirstPage: t6,
      nextPageCursor: undefined,
      loadMoreProjects: loadNoMoreProjects,
      totalCount: projects.length
    };
    $[13] = projects;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}